module.exports = __webpack_public_path__ + "static/media/rainfall_2.c306dee5.png";